import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGallery, updateGallery } from '../actions/galleryActions';
import { useNavigate, useParams } from 'react-router-dom';
import GalleryEditForm from './GalleryEditForm';
import Paper from '@mui/material/Paper';
import { loadCategories } from '../actions/categoryActions';
import { adminPageRootStyle } from './styles';

const GalleryEditPage = () => {
    const [gallery, setGallery] = useState(null);
    const [coverSrc, setCoverSrc] = useState('');
    const [coverImage, setCoverImage] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { galleryId } = useParams();

    const categories = useSelector(state => state.category.categories);
    const galleryRedux = useSelector(state => state.gallery.gallery);

    useEffect(() => {
        dispatch(loadCategories());
        dispatch(getGallery(galleryId));
    }, [dispatch, galleryId]);

    useEffect(() => {
        if (galleryRedux) {
            setGallery({ ...galleryRedux });
            setCoverSrc(galleryRedux.coverURL);
        }
    }, [galleryRedux]);

    const handleGalleryChange = useCallback((g) => {
        setGallery(g);
    }, []);

    const handleCoverImageChange = useCallback(({ file, fileURL }) => {
        setCoverSrc(fileURL);
        setCoverImage(file);
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        dispatch(updateGallery(galleryId, gallery, coverImage, navigate));
    }, [galleryId, gallery, coverImage, navigate, dispatch]);

    return (
        <Paper style={adminPageRootStyle}>
            <h2>Edit Gallery</h2>
            <GalleryEditForm
                handleSubmit={handleSubmit}
                gallery={gallery}
                handleGalleryChange={handleGalleryChange}
                coverSrc={coverSrc}
                handleCoverImageChange={handleCoverImageChange}
                categories={categories}
            />
        </Paper>
    );
};

export default GalleryEditPage;
